module.exports = __webpack_public_path__ + "static/media/bacon.b3bd8d7c.svg";